/**
 * Returns the cookie value from the decoded string of cookies if it exists, blank otherwise.
 * @param cookieName - Name of cookie to be found.
 * @returns {string}
 */
export function getCookie(cookieName) {
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split(';');
  const matchingKeyValue = cookies.find((element) => cookieName === element.split('=')[0].trim());
  return matchingKeyValue ? matchingKeyValue.split('=')[1] : '';
}

/**
 * Sets a cookie in the browser.
 * @param cookieName - Name of cookie to be set.
 * @param cookieValue - Value of the cookie.
 * @param expiryInMilliseconds - The expiry time to be set for the cookie. Set to the given date if not defined.
 */
export function setCookie(cookieName, cookieValue, date, days = 0) {
  const expiryDate = new Date(date);
  expiryDate.setDate(expiryDate.getDate() + days);
  const expiresStr = `expires=${expiryDate.toUTCString()}`;
  document.cookie = `${cookieName}=${cookieValue};${expiresStr};path=/`;
}
